import './style.scss';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useWindowResize } from '../../hooks';

const HeaderPhoto = ({ mobileImageUrl, desktopImageUrl }) => {
  const { width: windowWidth } = useWindowResize();
  const imageUrl =
    windowWidth >= 1024
      ? desktopImageUrl || 'https://zoolife.tv/assets/login-signup-image-desktop-8.webp'
      : mobileImageUrl || 'https://zoolife.tv/assets/login-signup-image-mobile-7.webp';

  return (
    <div className="headerPhoto">
      <button type="button" className="backButton" onClick={() => window.open('https://zoolife.tv/', '_self')}>
        <FontAwesomeIcon icon={faArrowLeft} color="var(--primaryGreen)" />
      </button>
      <img src={imageUrl} alt="Login Signup" />
    </div>
  );
};

export default HeaderPhoto;
